import styled from 'styled-components';

/**
 * =====================================================================
 * ESTILOS DA CONFIRMAÇÃO DE EXCLUSÃO EM LOTE
 * ---------------------------------------------------------------------
 * O overlay é position:fixed e a caixa é montada em portal no body, para
 * a confirmação nunca ser recortada pelo overflow da coluna de itens nem
 * ficar por baixo do desenho no modo tela cheia.
 * =====================================================================
 */
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;

  background: rgba(23, 38, 59, 0.55);
`;

export const Caixa = styled.div`
  display: flex;
  flex-direction: column;

  width: 460px;
  max-width: 100%;
  max-height: calc(100vh - 32px);

  background: #fff;
  border-radius: 12px;
  box-shadow: 0 18px 46px rgba(23, 38, 59, 0.35);

  overflow: hidden;
`;

Caixa.Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 14px 18px;
  border-bottom: 1px solid #eef2f7;

  > svg {
    flex: 0 0 auto;
    color: #de3b3b;
  }

  > strong {
    font-size: 15px;
    color: #2c405a;
  }
`;

Caixa.Body = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 14px 18px;

  > p {
    font-size: 13px;
    line-height: 1.45;
    color: #475569;
  }
`;

/** lista dos itens que serão apagados, para conferência antes de digitar */
Caixa.Lista = styled.ul`
  margin: 10px 0 0;
  padding: 8px 10px;
  max-height: 168px;
  overflow-y: auto;

  list-style: none;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;

  > li {
    display: flex;
    justify-content: space-between;
    gap: 10px;

    padding: 3px 0;
    font-size: 12px;
    color: #334155;

    & + li {
      border-top: 1px dashed #e8eef5;
    }

    > span:first-child {
      font-weight: 700;
    }

    > span:last-child {
      color: #64748b;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

/** aviso de itens que possuem link no desenho */
Caixa.Aviso = styled.div`
  display: flex;
  gap: 8px;

  margin-top: 12px;
  padding: 9px 11px;

  font-size: 12px;
  line-height: 1.4;
  color: #8a5300;

  background: #fff7ea;
  border: 1px solid #ffe0b2;
  border-radius: 8px;
`;

Caixa.Campo = styled.label`
  display: block;
  margin-top: 14px;

  > span {
    display: block;
    margin-bottom: 6px;
    font-size: 12.5px;
    color: #475569;

    > b {
      color: #de3b3b;
      letter-spacing: 0.06em;
    }
  }

  > input {
    width: 100%;
    padding: 9px 11px;

    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #2c405a;

    border: 1px solid #cbd5e1;
    border-radius: 8px;
    background: #fff;

    &:focus {
      border-color: #de3b3b;
      box-shadow: 0 0 0 3px rgba(222, 59, 59, 0.15);
    }
  }
`;

Caixa.Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  padding: 12px 18px;
  border-top: 1px solid #eef2f7;
  background: #fbfcfe;

  > button {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    padding: 9px 16px;

    font-size: 13px;
    font-weight: 600;

    border: 1px solid #d8e0eb;
    border-radius: 8px;
    background: #fff;
    color: #475569;
    cursor: pointer;

    &:hover:not(:disabled) {
      background: #f1f5f9;
    }

    &.perigo {
      color: #fff;
      background: #de3b3b;
      border-color: transparent;

      &:hover:not(:disabled) {
        background: #c53030;
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;
